import React, { Fragment, useState, useEffect } from 'react';
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
  Dialog,
  tableCellClasses,
} from '@mui/material';
import Pagination from "components/Pagination";
import InputField from 'components/Input';
import DatePicker from 'components/DatePicker'; // Assuming you have a DatePicker component
import { PrimaryButton } from 'components/Buttons'; // Assuming you have a custom button component
import Colors from 'assets/Style/Colors';
import { FontFamily, SearchIcon } from 'assets';
import ClientServices from 'services/Client';
import moment from "moment";
import DropdownMenu from "components/DropDown";
import { useNavigate } from "react-router-dom";
import { ErrorToaster, SuccessToaster } from 'components/Toaster';
import { useForm } from "react-hook-form";
import { CircleLoading } from "components/Loaders";
import styled from "@emotion/styled";

const useStyles = {
  tableHeader: {
    backgroundColor: '#f5f5f5',
    fontWeight: 'bold',
  },
  tableCell: {
    // textAlign: 'center',
  },
  notesTextArea: {
    width: '100%',
    marginTop: '20px',
  },
};

const Row = styled(TableRow)({ border: 0 });
const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",
    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));


const SpecialDiscountList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDateFrom, setSelectedDateFrom] = useState(null);
  const [selectedDateTo, setSelectedDateTo] = useState(null);
  const [originalData, setOriginalData] = useState([]); // Store the original unfiltered data
  const [filteredRows, setFilteredRows] = useState([]); // This will hold the filtered results
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeMenu, setActiveMenu] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [filters, setFilters] = useState({});
  const [loader, setLoader] = useState(false);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [ID, setID] = useState();
  const [subTotal, setSubTotal] = useState(0);
  

  const {
    register,
    getValues,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();


  const [vinTotals, setVinTotals] = useState({});

  const getAllSLPVehicles = async (page, limit, filter) => {
    try {
      setLoader(true);
      const Page = page ? page : currentPage;
      const Limit = limit ? limit : pageLimit;
      const Filter = { ...filters, ...filter };
      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);

      let params = {
        page: Page,
        limit: Limit,
      };

      params = { ...params, ...Filter };

      const { data } = await ClientServices.specialDiscountList(params);
      setOriginalData(data); // Store the original data
      setFilteredRows(data?.sds?.rows); // Initialize filtered data with all vehicles
      setTotalCount(data?.sds?.count);


      let finalTotal = 0;
      let vinSumMap = {};
      data?.slps?.rows.forEach((item) => {

        const vin = item?.booking?.vin;
        const total = parseFloat(item?.total || 0);
        if (!vin) return;

        vinSumMap[vin] = (vinSumMap[vin] || 0) + total;


        finalTotal += parseFloat(item?.total);
      });

      setVinTotals(vinSumMap); // ⬅️ 

      setSubTotal(finalTotal);


    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };


  const handleDelete = async () => {
    try {

      if (!ID) {
        throw new Error("Discount ID not found for the selected special.");
      }
      const params = {
            discount_id:ID,  
        };
      await ClientServices.getDeleteSpecialDiscount(params);
      SuccessToaster("Special Discount deleted successfully");
      setOpenDeleteModal(false);
      getAllSLPVehicles();

    } catch (error) {
      ErrorToaster(error);
    }
  };



  useEffect(() => {
    getAllSLPVehicles();
  }, []);


  const handleFromDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setFromDate("invalid");
        return;
      }
      setFromDate(new Date(newDate));
      handleFilter({ from_date: moment(new Date(newDate)).format('YYYY-MM-DD') })
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleToDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setToDate("invalid");
        return;
      }
      setToDate(new Date(newDate));
      handleFilter({ to_date: moment(new Date(newDate)).format('YYYY-MM-DD') })

    } catch (error) {
      ErrorToaster(error);
    }
  };


  // Call handleSearch when the search button is clicked
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleMenuToggle = (menuId, isOpen) => {
    setActiveMenu(isOpen ? menuId : null); // Toggle the active menu
  };

  const handleFilter = async (data) => {
    if (!data) {
      return;
    }

    setLoader(true);
    if (isSearching) return;


    setIsSearching(true);
    try {
      await getAllSLPVehicles(1, "", data);

    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      setIsSearching(false);
      setLoader(false);
    }
  }

 const creditCustomerCounts = Array.isArray(filteredRows)
  ? filteredRows.reduce((acc, row) => {
      const creditCustomer = row?.creditCustomer?.id || 'unknown';
      acc[creditCustomer] = (acc[creditCustomer] || 0) + 1;
      return acc;
    }, {})
  : {};


  return (
    <Fragment>
      <Dialog
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Typography
          sx={{
            p: 3,
            px: 5,
            fontSize: 17,
            fontFamily: FontFamily.openSans,
            fontWeight: "bold",
          }}
          id="alert-dialog-title"
        >
          {"Are You Sure You Want To Delete special discount enteries?"}
        </Typography>

        <Grid item xs={12} sm={12} sx={{ mb: 2, textAlign: "center" }}>
          <PrimaryButton
            title="No"
            type="submit"
              buttonStyle={{
              minWidth: "120px",
            }}
            onClick={() => {
              setOpenDeleteModal(false);
            }}
          />
          <Box component={"span"} sx={{ mx: 1 }} />
          <PrimaryButton
            title="Yes"
            type="button"
            buttonStyle={{ minWidth: "120px",
              bgcolor: Colors.danger,
              "&:hover": { bgcolor: Colors.danger }
             }}
            bgcolor={Colors?.danger}
            onClick={() => {
              handleDelete();
            }}
          />
        </Grid>
      </Dialog>
      <Grid container
        spacing={1}
        alignItems={'center'}
        justifyContent={'center'}>
        <Grid item xs={12} sm={12} md={11}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              mr: 4,
              my: 4,
            }}
          >
            <Typography
              variant='h4'
              sx={{
                color: Colors.charcoalGrey,
                fontFamily: FontFamily.NunitoRegular,
              }}
            >
              Special Discount List
            </Typography>

          </Box>
        </Grid>
        {/* Filters */}
        <Grid item md={11}>
          <Box
            sx={{
              m: '10px 0 10px 0',
              // p: '20px',
              // bgcolor: Colors.feta,
              // border: `1px solid ${Colors.iron}`,
              // borderRadius: '9px',

            }}
          >
            <Grid
              container
              spacing={1}
              alignItems={'center'}
              justifyContent={'space-between'}
              component={'form'}
              onSubmit={handleSubmit}
            >
              <Grid item xs={12} md={3} sx={{marginTop: '5px'}}>

                <InputField
                  size={"small"}
                  inputStyle={{ backgroundColor: "#f5f5f5" }}
                  label={"Search"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  placeholder={"Search"}
                  register={register("search", {
                    onChange: (e) => handleFilter({ search: e.target.value }),
                  })}
                />
              </Grid>
              <Grid item xs={12} md={3}>

                <DatePicker
                  disableFuture={true}
                  size="small"
                  label={"From Date"}
                  value={fromDate}
                  onChange={(date) => handleFromDate(date)}
                />
              </Grid>
              <Grid item xs={12} md={3}>

                <DatePicker
                  disableFuture={true}
                  size="small"
                  minDate={fromDate}
                  label={"To Date"}
                  value={toDate}
                  onChange={(date) => handleToDate(date)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Box
                  sx={{
                    mt: "28px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <PrimaryButton
                    title={"Search"}
                    onClick={() => {
                      if (!fromDate || !toDate) {
                        ErrorToaster("Please select both From and To dates");
                        return;
                      }
                      handleFilter({
                        from_date: moment(fromDate).format("YYYY-MM-DD"),
                        to_date: moment(toDate).format("YYYY-MM-DD"),
                      });
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box>
            {loader ? (
              <Box
                sx={{
                  height: "300px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircleLoading />
              </Box>
            ) : (
              <>
                <TableContainer
                  sx={{
                    borderRadius: 2,
                    maxWidth: 'calc(100vw - 330px)',
                  }}
                >
                  <Table stickyHeader sx={{ minWidth: 500 }}>
                    <TableHead>
                      <TableRow>
                        <Cell sx={{ bgcolor: Colors.primary, color: 'white', fontWeight: 'bold' }}>Ref.No</Cell>
                        <Cell sx={{ bgcolor: Colors.primary, color: 'white', fontWeight: 'bold' }}>Particular#</Cell>
                        <Cell sx={{ bgcolor: Colors.primary, color: 'white', fontWeight: 'bold' }}>P.Date</Cell>
                        <Cell sx={{ bgcolor: Colors.primary, color: 'white', fontWeight: 'bold' }}>C.Date</Cell>
                        <Cell sx={{ bgcolor: Colors.primary, color: 'white', fontWeight: 'bold' }}>Against Client</Cell>
                        <Cell sx={{ bgcolor: Colors.primary, color: 'white', fontWeight: 'bold' }}>Credit To</Cell>
                        <Cell sx={{ bgcolor: Colors.primary, color: 'white', fontWeight: 'bold' }}>Total Amount $</Cell>
                        <Cell sx={{ bgcolor: Colors.primary, color: 'white', fontWeight: 'bold' }}># Of Vin</Cell>
                        <Cell sx={{ bgcolor: Colors.primary, color: 'white', fontWeight: 'bold' }}>User</Cell>
                        <Cell sx={{ bgcolor: Colors.primary, color: 'white', fontWeight: 'bold' }}>Action</Cell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredRows.length > 0 ? (
                        <Fragment>
                          {filteredRows.map((row, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                bgcolor: filteredRows.indexOf(row) % 2 !== 0 ? '#EFF8E7' : 'inherit',
                              }}
                            >
                              <Cell>{row?.reference_no ?? '-'}</Cell>
                              <Cell>{row?.id ? `GSD-${row?.id}` : '-'}</Cell>
                              <Cell>{moment(row?.created_at).format("MM-DD-YYYY") ?? '-'}</Cell>
                              <Cell>{moment(row?.date).format("MM-DD-YYYY") ?? '-'}</Cell>
                              <Cell>{row?.booking?.customer?.name ?? '-'}</Cell>
                              <Cell>{row?.creditCustomer?.name ?? '-'}</Cell>
                              <Cell>{row?.total ?? '-'}</Cell>
                              <Cell>{row?.vin_count ?? '-'}</Cell>
                              <Cell>{row?.user?.name ?? '-'}</Cell>
                              <Cell>{
                                <DropdownMenu
                                  item={row}
                                  // permissions={permissions}
                                  navigate={navigate}
                                  isOpen={activeMenu === row.id}
                                  onToggle={(isOpen) => handleMenuToggle(row?.id, isOpen)}
                                  id={row?.id}
                                  onClickViewSpecialDiscount={() => {
                                    window.open(`/special-discount-detail/${row?.special_dis_id}`)
                                  }}
                                  onClickEditSpecialDiscount={() => { navigate(`/update-special-discount/${row?.special_dis_id}` )}}
                                  onClickDeleteSpecialDiscount={() => {
                                    setOpenDeleteModal(true);
                                    setID(row?.special_dis_id);

                                    }
                                  }
                                />
                              }</Cell>
                            </TableRow>
                          ))}
                          {/* <TableRow>
                            <Cell colSpan={10}>
                              <Typography
                                className="pdf-table"
                                variant="body1"
                                sx={{ fontWeight: 700 }}
                              >
                                Final Total
                              </Typography>
                            </Cell>


                            <Cell colSpan={3}>
                              <Typography
                                className="pdf-table"
                                variant="body1"
                                sx={{ fontWeight: 700 }}
                              >
                                $
                                {CommaSeparator(
                                  parseFloat(subTotal).toFixed(2)
                                )}
                              </Typography>
                            </Cell>
                            <Cell></Cell>
                            <Cell></Cell>
                            <Cell></Cell>
                          </TableRow> */}
                        </Fragment>
                      ) : (
                        <TableRow>
                          <Cell
                            colSpan={11}
                            sx={{
                              textAlign: "center",
                              fontWeight: "bold",
                              fontFamily: FontFamily.NunitoRegular,
                              fontSize: "16px",
                            }}
                          >
                            <Box
                              sx={{
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              No Data Found
                            </Box>
                          </Cell>
                        </TableRow>


                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* ========== Pagination ========== */}
                <Pagination
                  currentPage={currentPage}
                  pageSize={pageLimit}
                  onPageSizeChange={(size) =>
                    getAllSLPVehicles(1, size.target.value)
                  }
                  tableCount={filteredRows?.length}
                  totalCount={totalCount}
                  onPageChange={(page) => getAllSLPVehicles(page, "")}
                />

              </>


            )}
          </Box>



        </Grid>

      </Grid>
    </Fragment>
  );
};

export default SpecialDiscountList;